var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.555 68.1197H6.44531C2.88578 68.1197 0 65.2339 0 61.6743V34.06C0 15.2793 15.2793 0 34.06 0H185.94C204.721 0 220 15.2793 220 34.06V61.6748C220 65.2339 217.114 68.1197 213.555 68.1197Z",
    fill: "#E1EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 61.6743V34.06C220 15.2793 204.721 0 185.94 0H110V68.1197H213.555C217.114 68.1197 220 65.2339 220 61.6743Z",
    fill: "#CFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.94 220H34.06C15.2793 220 0 204.721 0 185.94V61.6743C0 58.1148 2.88578 55.229 6.44531 55.229H213.555C217.114 55.229 220 58.1148 220 61.6743V185.94C220 204.721 204.721 220 185.94 220Z",
    fill: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 185.94V61.6743C220 58.1148 217.114 55.229 213.555 55.229H110V220H185.94C204.721 220 220 204.721 220 185.94Z",
    fill: "#E1EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.325 116.445C154.766 116.445 151.88 113.56 151.88 110V103.096C151.88 99.5367 154.766 96.6509 158.325 96.6509C161.885 96.6509 164.771 99.5367 164.771 103.096V110C164.771 113.56 161.885 116.445 158.325 116.445Z",
    fill: "#070F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9629 40.5054H34.0596C30.5 40.5054 27.6143 37.6196 27.6143 34.0601C27.6143 30.5005 30.5 27.6147 34.0596 27.6147H40.9629C44.5225 27.6147 47.4082 30.5005 47.4082 34.0601C47.4082 37.6196 44.5225 40.5054 40.9629 40.5054Z",
    fill: "#FC5896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0298 40.5054H65.126C61.5664 40.5054 58.6807 37.6196 58.6807 34.0601C58.6807 30.5005 61.5664 27.6147 65.126 27.6147H72.0298C75.5893 27.6147 78.4751 30.5005 78.4751 34.0601C78.4751 37.6196 75.5893 40.5054 72.0298 40.5054Z",
    fill: "#FFC54D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.096 40.5054H96.1924C92.6329 40.5054 89.7471 37.6196 89.7471 34.0601C89.7471 30.5005 92.6329 27.6147 96.1924 27.6147H103.096C106.656 27.6147 109.541 30.5005 109.541 34.0601C109.541 37.6196 106.656 40.5054 103.096 40.5054Z",
    fill: "#00D048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6748 116.445C58.1153 116.445 55.2295 113.56 55.2295 110V103.096C55.2295 99.5367 58.1153 96.6509 61.6748 96.6509C65.2343 96.6509 68.1201 99.5367 68.1201 103.096V110C68.1201 113.56 65.2343 116.445 61.6748 116.445Z",
    fill: "#142D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.799 137.41C112.602 134.214 107.398 134.214 104.201 137.41C101.683 139.926 97.602 139.926 95.0858 137.407C92.5695 134.89 92.5704 130.808 95.0883 128.292C103.31 120.074 116.689 120.074 124.911 128.292C127.429 130.808 127.43 134.89 124.914 137.407C122.398 139.925 118.316 139.926 115.799 137.41Z",
    fill: "#142D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.914 137.407C127.43 134.89 127.429 130.809 124.911 128.292C120.801 124.184 115.4 122.129 110 122.129V135.013C112.1 135.013 114.2 135.811 115.799 137.409C118.316 139.926 122.398 139.925 124.914 137.407Z",
    fill: "#070F15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/page-not-found.335930572fdb1c915d7a95373f5bb5eb.svg";
export { ForwardRef as ReactComponent };